<script>
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import dateFormat from "@/shared/lib/date-format";

export default {
  name: "LoggingAction",
  components: { InformationLayout },
  props: {
    logItem: {
      type: Object,
      default: () => null,
    },
    roles: {
      type: Array,
      default: () => [],
    },
    roleName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    sections() {
      const item = this.logItem;
      const notSpecified = this.$t("Не указано");

      return [
        {
          title: this.$t("Действие пользователя"),
          items: [
            {
              label: this.$t("Дата и время действия"),
              values: [
                { text: this.dateFormat(item?.timestamp) || notSpecified },
              ],
            },
            {
              label: this.$t("Пользователь"),
              values: [{ text: this.formatFio(item?.fio) || notSpecified }],
            },
            {
              label: this.$t("ИИН пользователя"),
              values: [{ text: item?.identifier || notSpecified }],
            },
            {
              label: this.$t("Роль"),
              values: [{ text: this.roleName }],
            },
            {
              label: this.$t("Рабочая станция"),
              values: [{ text: item?.ip || notSpecified }],
            },
            {
              label: "Модуль",
              values: [{ text: item?.service || notSpecified }],
            },
            {
              label: this.$t("Действие"),
              values: [{ text: item?.action_description || notSpecified }],
            },
          ],
        },
      ];
    },
  },
  methods: {
    dateFormat(date) {
      if (!date) {
        return null;
      }
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY HH:mm");
    },
    formatFio(fio) {
      if (!fio) return "";
      const parts = fio.trim().split(/\s+/);
      if (parts.length === 0) return "";

      if (parts.length >= 2) {
        const firstName = parts[0];
        const surname = parts[1];
        const patronymic = parts[2];

        const surnameFormatted =
          surname.charAt(0).toUpperCase() + surname.slice(1).toLowerCase();
        const firstInitial = firstName.charAt(0).toUpperCase() + ".";
        const patronymicInitial = patronymic
          ? patronymic.charAt(0).toUpperCase() + "."
          : "";

        return `${surnameFormatted} ${firstInitial}${patronymicInitial}`;
      }

      return parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
    },
  },
};
</script>

<template>
  <div class="block">
    <InformationLayout :showHeader="false" :sections="sections" />
  </div>
</template>

<style scoped lang="scss">
.block {
  @apply h-full w-full overflow-auto bg-white rounded-2xl p-8;
}

@media (max-width: 1400px) {
  .block {
    @apply w-full;
  }
}
</style>
